import React from 'react';
import { ThemeProvider, Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';

import CalendarMain from './CalendarMain';
import EventDialog from './EventDialog';
import MobileNavigation from './MobileNavigation';
import FilterSidebar from './FilterSidebar';
import LoadingSpinner from '../Common/LoadingSpinner';
import ErrorMessage from '../Common/ErrorMessage';

import { useAuth } from '../../hooks/useAuth';
import { useCalendarState } from '../../hooks/useCalendarState';
import { useCalendarEvents } from '../../hooks/useCalendarEvents';

import { theme } from '../../utils/colors';

const FullCalendarComponent = (props) => {
  const { user: parentUser = null, isDesk: parentIsDesk = null, onSignOut: parentSignOut = () => {} } = props;
  const isMobile = useMediaQuery('(max-width:1280px)');

  // displayName と currentUser はカスタムフックから取得（内部状態を優先）
  const { currentUser, isLoading, displayName } = useAuth();
  const calendarState = useCalendarState(currentUser);
  const calendarEvents = useCalendarEvents(currentUser, isLoading, calendarState.autoUpdate);

  if (isLoading) return <LoadingSpinner />;
  if (!currentUser || !currentUser.isAuthenticated) return <ErrorMessage message="ログインしてください" />;

  // 親/内部どちらかで Desks 判定が取れればデスク扱いにする
  const effectiveIsDesk = Boolean(parentIsDesk || currentUser?.isDesk || (currentUser?.groups || []).includes('Desks'));
  const effectiveUser = parentUser ?? currentUser;
  const effectiveSignOut = parentSignOut;

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          maxWidth: 1920,
          mx: 'auto',
          bgcolor: 'background.paper',
          boxShadow: 3,
        }}
      >
        <CalendarMain
          isMobile={isMobile}
          calendarState={calendarState}
          calendarEvents={calendarEvents}
          currentUser={effectiveUser}
        />

        <EventDialog
          calendarState={calendarState}
          calendarEvents={calendarEvents}
          isDesk={effectiveIsDesk}
          // 親からの user（parentUser）があれば優先して渡す
          currentUser={parentUser ?? currentUser}
          displayName={displayName}
        />

        {isMobile && <MobileNavigation calendarState={calendarState} />}

        <FilterSidebar
          isMobile={isMobile}
          calendarState={calendarState}
          user={effectiveUser}
          isDesk={effectiveIsDesk}
          onSignOut={effectiveSignOut}
        />
      </Box>
    </ThemeProvider>
  );
};

export default FullCalendarComponent;
